import { RfUiInput } from 'renfe-components';

export const ObservationsContainer = ({
  title,
  disableObservationAlumn,
  valueObservation,
  handleObservationsChange,
}) => {
  return (
    <div className="rf-practice-detail__input-container--padding-right">
      <h2 className="rf-title rf-title--secundary">{title}</h2>
      <div className="rf-practice-detail__input-container">
        <RfUiInput
          label={title}
          className="rf-input"
          error=""
          disabled={disableObservationAlumn}
          value={valueObservation}
          onValueChanges={(e) => handleObservationsChange(e.detail ?? '')}
        ></RfUiInput>
      </div>
    </div>
  );
};
